module.exports = __webpack_public_path__ + "media/images/apple-touch-icon-509b9036.png";